/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, date: NonNullable<unknown> }} Plan_Tab_Downgrade_SuccessInputs */



/**
* | output |
* | --- |
* | "Your plan will change to {plan} on {date}." |
*
* @param {Plan_Tab_Downgrade_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_success = /** @type {((inputs: Plan_Tab_Downgrade_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dein Plan wechselt am ${i?.date} zu ${i?.plan}.`)
	return /** @type {LocalizedString} */ (`Your plan will change to ${i?.plan} on ${i?.date}.`)
});